import * as LogRocket from 'logrocket'

import { environment } from '../environments/environment'

LogRocket.init(environment.logRocketKey, {
  release: environment.commit,
  network: {
    responseSanitizer: response => {
      response.body = null
      return response
    }
  },
  shouldCaptureIP: false,
})
